import { useCallback } from 'react';

import { generatePath } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { env } from '@packages/utils/env';
import { RISK_MANAGEMENT_RISKS_ALL_ROUTE } from 'ae-constants/routes.constants';
import { useRendallOrganization } from 'ae-kernel/organizations/use-rendall-organization';

export const useRiskManagementDetails = () => {
  const [riskM1FF] = useFeatureFlag('RISKS_IN_UP_M1');
  const [evaM1FF] = useFeatureFlag('EVA_IN_UP_M1');

  const { organizationId, currentOrganization, isPending } =
    useRendallOrganization();

  const isRisksAvailableInUP =
    riskM1FF && !isPending && currentOrganization?.flags.risksInUpM1;

  const getRiskManagementEndpoint = useCallback(
    (assetId: string, queryParams: string) =>
      isRisksAvailableInUP
        ? generatePath(
            `${RISK_MANAGEMENT_RISKS_ALL_ROUTE}?assetID=${assetId}${evaM1FF ? '&assetType=device' : ''}&${queryParams}`,
          )
        : `${env.VITE_MANAGED_RISK_BASE_PATH}/risks?id=${organizationId}&adsAssetId=${assetId}&${queryParams}`,
    [evaM1FF, isRisksAvailableInUP, organizationId],
  );

  return { isRisksAvailableInUP, getRiskManagementEndpoint };
};
